import React from "react";
import "../css/about.scss";

function About() {
  return (
    <div className="about">
      <div className="about__container">
        <h1 className="about__title">ABOUT</h1>

        <div className="about__content">
          <p className="about__paragraph">
            Welcome to Tuddlepetgoods, where every piece tells a story. We
            specialize in curating and creating extraordinary jewelry that
            transcends time.
          </p>

          <p className="about__paragraph">
            Founded on the belief that jewelry should be both beautiful and
            meaningful, we search the world for exceptional vintage pieces while
            crafting contemporary designs that honor traditional craftsmanship.
          </p>

          <p className="about__paragraph">
            Our collection features a carefully curated selection of vintage
            treasures, contemporary creations, and custom pieces. Each item is
            chosen for its unique character, exceptional quality, and the story
            it carries.
          </p>

          <h2 className="about__subtitle">OUR PHILOSOPHY</h2>

          <p className="about__paragraph">
            We believe in jewelry that lasts. Pieces that can be worn today,
            cherished tomorrow, and passed down for generations. Our commitment
            to quality ensures that every piece in our collection meets the
            highest standards of craftsmanship.
          </p>

          <p className="about__paragraph">
            Whether you're searching for a vintage engagement ring, a special
            piece for a loved one, or a treat for yourself, we're here to help
            you find something truly special.
          </p>

          <h2 className="about__subtitle">CUSTOM &amp; COMMISSION</h2>

          <p className="about__paragraph">
            Looking for something truly one-of-a-kind? We offer custom design
            services and can work with you to create a piece that's uniquely
            yours. From engagement rings to heirloom redesigns, we love bringing
            your vision to life.
          </p>

          <p className="about__paragraph">
            To discuss a custom piece or learn more about our process, please
            contact us at{" "}
            <a href="mailto:wares@tuddlepetgoods.club" className="about__link">
              wares@tuddlepetgoods.club
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
